module.exports = __webpack_public_path__ + "static/media/logo.7e06f53f.png";